(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-block"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener("load", (event) => {
    document.querySelectorAll('.color-block__slider').forEach((colorProductsSlider) => {
      let productsSlider = new Flickity(colorProductsSlider, {
        imagesLoaded: true,
        autoPlay: 5000,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: true,
        adaptiveHeight: true
      })

      window.addEventListener('load', function () {
        productsSlider.resize();
        setTimeout(() => {
          productsSlider.resize();
        }, 500);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colors-intro"]) return;
  try {
    
window.addEventListener("load", (event) => {
  document.querySelectorAll('[data-colors-navigation]').forEach((navigation) => {
    document.querySelectorAll('[data-color-block]').forEach((section) => {
      const sectionId = section.closest('.shopify-section').id;
      const circleHTML = section.querySelector('.color-circle-container').innerHTML;
      navigation.innerHTML += `<a href="#${sectionId}">${circleHTML}</a>`;
    });
  });

  document.querySelectorAll('[data-navigation-appear-here]').forEach((navigation) => {
    let hasScrollPassed = false;
    // on scrolling
    window.addEventListener("scroll", function() {
      // Chech when section is half way inside viewport
      const navigationOffset = navigation.offsetTop;
      // check if we are above or below section
      if (window.scrollY < navigationOffset) {
        // above section
        if (hasScrollPassed) {
          document.querySelector('[data-navigation-appear]').classList.remove('navigation-is-visible');
          hasScrollPassed = false;
        }
      } else {
        // below section
        if (!hasScrollPassed) {
          document.querySelector('[data-navigation-appear]').classList.add('navigation-is-visible');
          hasScrollPassed = true;
        }
      }
    });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
    document.addEventListener('alpine:init', () => {
        const sectionIcons = JSON.parse(document.querySelector('.faq').getAttribute('data-icons'));
        Alpine.data('faq', () => ({
            content: [],
            open: '',
            currentSection: '',
            init() {
                const self = this;
                fetch('https://finlayson.zendesk.com/api/v2/help_center/fi/categories')
                    .then(response => response.json())
                    .then(data => {
                        self.content = data.categories;
                        self.fetchSections();
                    });
            },
            fetchSections() {
                const self = this;
                self.content.forEach((category, index) => {
                    fetch(`https://finlayson.zendesk.com/api/v2/help_center/fi/categories/${category.id}/sections`)
                        .then(response => response.json())
                        .then(data => {
                            self.content[index]['sections'] = data.sections;
                            self.fetchArticles();
                        });
                
                   
                });
            },
            fetchArticles() {
                const self = this;
                self.content.forEach((category, categoryIndex) => {
                    if (category.sections) {
                        category.sections.forEach((section, sectionIndex) => {
                            sectionIcons.icons.forEach((icon, index) => {
                                if (icon.text.toLowerCase() == section.name.toLowerCase()) {
                                    self.content[categoryIndex].sections[sectionIndex].icon = icon;
                                }
                            })
                            fetch(`https://finlayson.zendesk.com/api/v2/help_center/fi/sections/${section.id}/articles`)
                                .then(response => response.json())
                                .then(data => {
                                    self.content[categoryIndex].sections[sectionIndex]['articles'] = data.articles;
                                });
                        });
                    }
                });
            },
            scrollEvent() {
                const self = this;
                document.querySelectorAll('.faq__section').forEach((section) => {
                    if (section.getBoundingClientRect().top <= 0) {
                        self.currentSection = section.getAttribute('id')
                    }
                });
            }
        }))
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const footerAccordions = document.querySelectorAll('.footer-block--accordion');
  footerAccordions.forEach((accordion) => {
    accordion.querySelector('.footer-block__heading').addEventListener('click', () => {
      accordion.classList.toggle('is-open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
	//ON SCROLL ANIMATION 
	function isInViewport(element) {
		// Get the bounding client rectangle position in the viewport
		var bounding = element.getBoundingClientRect();
		//Using vh
		var scrollOffset = (element.hasAttribute("data-scroll-offset")) ? document.documentElement.clientHeight * parseFloat(element.getAttribute('data-scroll-offset')) : 0;
		// Checking part. Here the code checks if it's *fully* visible
		// Edit this part if you just want a partial visibility
		if (bounding.top <= scrollOffset) {
			return true;
		} else {
			return false;
		}
	}

	window.addEventListener("load", (event) => {
		// Get the an HTML element
		var elements = document.querySelectorAll('.animate-on-scroll');

		for (let i = 0; i < elements.length; i += 1) {
			if (isInViewport(elements[i]) && !elements[i].classList.contains('in-view')) {
				elements[i].classList.add('in-view')
			}
		}

		window.addEventListener('scroll', function (event) {
			for (let i = 0; i < elements.length; i += 1) {
				if (isInViewport(elements[i]) && !elements[i].classList.contains('in-view')) {
					elements[i].classList.add('in-view')
				}
			}
		}, false);
	});

  } catch(e) { console.error(e); }
})();
})();
